/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Feedback } from '../model/feedback';
import { FeedbackDTO } from '../model/feedbackDTO';
import { FeedbackMessage } from '../model/feedbackMessage';
import { FeedbackMessageDTO } from '../model/feedbackMessageDTO';
import { PaginatedModelOfFeedbackMessage } from '../model/paginatedModelOfFeedbackMessage';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FeedbackService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param serviceCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public feedbackGetAllFeedback(serviceCode?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Feedback>>;
    public feedbackGetAllFeedback(serviceCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Feedback>>>;
    public feedbackGetAllFeedback(serviceCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Feedback>>>;
    public feedbackGetAllFeedback(serviceCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceCode !== undefined && serviceCode !== null) {
            queryParameters = queryParameters.set('serviceCode', <any>serviceCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Feedback>>(`${this.basePath}/api/Feedback/GetAllFeedback`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param feedbackId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public feedbackGetAllFeedbackMessages(feedbackId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<FeedbackMessage>>;
    public feedbackGetAllFeedbackMessages(feedbackId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FeedbackMessage>>>;
    public feedbackGetAllFeedbackMessages(feedbackId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FeedbackMessage>>>;
    public feedbackGetAllFeedbackMessages(feedbackId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (feedbackId !== undefined && feedbackId !== null) {
            queryParameters = queryParameters.set('feedbackId', <any>feedbackId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<FeedbackMessage>>(`${this.basePath}/api/Feedback/GetAllFeedbackMessages`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param feedbackId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public feedbackGetAllPaginatedFeedbackMessages(feedbackId?: number, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfFeedbackMessage>;
    public feedbackGetAllPaginatedFeedbackMessages(feedbackId?: number, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfFeedbackMessage>>;
    public feedbackGetAllPaginatedFeedbackMessages(feedbackId?: number, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfFeedbackMessage>>;
    public feedbackGetAllPaginatedFeedbackMessages(feedbackId?: number, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (feedbackId !== undefined && feedbackId !== null) {
            queryParameters = queryParameters.set('feedbackId', <any>feedbackId);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfFeedbackMessage>(`${this.basePath}/api/Feedback/GetAllPaginatedFeedbackMessages`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public feedbackInsertFeedback(model: FeedbackDTO, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public feedbackInsertFeedback(model: FeedbackDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public feedbackInsertFeedback(model: FeedbackDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public feedbackInsertFeedback(model: FeedbackDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling feedbackInsertFeedback.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/Feedback/InsertFeedback`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public feedbackInsertFeedbackMessage(model: FeedbackMessageDTO, observe?: 'body', reportProgress?: boolean): Observable<FeedbackMessage>;
    public feedbackInsertFeedbackMessage(model: FeedbackMessageDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FeedbackMessage>>;
    public feedbackInsertFeedbackMessage(model: FeedbackMessageDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FeedbackMessage>>;
    public feedbackInsertFeedbackMessage(model: FeedbackMessageDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling feedbackInsertFeedbackMessage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FeedbackMessage>(`${this.basePath}/api/Feedback/InsertFeedbackMessage`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
